/* src/app/workshop/components/workshop-vehicles/vehicle-view/vehicle-view.component.scss */
table,
tr,
th,
td {
  text-align: center;
}
/*# sourceMappingURL=vehicle-view.component.css.map */
